import $ from "jquery";

export const init = function () {
  // -------------------------------------------------------------------
  // jquery.equalizeHeight
  // -------------------------------------------------------------------
  // $.fn.equalizeHeight = function (selector) {
  //   return this.each(function () {
  //     var height = 0;
  //     $(this)
  //       .find(selector)
  //       .each(function () {
  //         if ($(this).height() > height) height = $(this).height();
  //       });
  //     height = Math.ceil(height);
  //     $(this)
  //       .find(selector)
  //       .each(function () {
  //         $(this).height(height);
  //       });
  //   });
  // };
  // -------------------------------------------------------------------

  // -------------------------------------------------------------------
  // jquery.equalizeHeight
  // -------------------------------------------------------------------
  "use strict";
  function _typeof(t) {
    return (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (t) {
            return typeof t;
          }
        : function (t) {
            return t &&
              "function" == typeof Symbol &&
              t.constructor === Symbol &&
              t !== Symbol.prototype
              ? "symbol"
              : typeof t;
          })(t);
  }
  !(function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "undefined" != typeof module && module.exports
      ? (module.exports = t(require("jquery")))
      : t(jQuery);
  })(function (l) {
    function c(t) {
      return parseFloat(t) || 0;
    }
    function p(t) {
      var e = l(t),
        n = null,
        r = [];
      return (
        e.each(function () {
          var t = l(this),
            e = t.offset().top - c(t.css("margin-top")),
            o = 0 < r.length ? r[r.length - 1] : null;
          null === o
            ? r.push(t)
            : Math.floor(Math.abs(n - e)) <= 1
            ? (r[r.length - 1] = o.add(t))
            : r.push(t),
            (n = e);
        }),
        r
      );
    }
    function h(t) {
      var e = { byRow: !0, property: "height", target: null, remove: !1 };
      return "object" === _typeof(t)
        ? l.extend(e, t)
        : ("boolean" == typeof t
            ? (e.byRow = t)
            : "remove" === t && (e.remove = !0),
          e);
    }
    var n = -1,
      r = -1,
      u = (l.fn.matchHeight = function (t) {
        var e = h(t);
        if (e.remove) {
          var o = this;
          return (
            this.css(e.property, ""),
            l.each(u._groups, function (t, e) {
              e.elements = e.elements.not(o);
            }),
            this
          );
        }
        return (
          (this.length <= 1 && !e.target) ||
            (u._groups.push({ elements: this, options: e }), u._apply(this, e)),
          this
        );
      });
    (u.version = "0.7.2"),
      (u._groups = []),
      (u._throttle = 80),
      (u._maintainScroll = !1),
      (u._beforeUpdate = null),
      (u._afterUpdate = null),
      (u._rows = p),
      (u._parse = c),
      (u._parseOptions = h),
      (u._apply = function (t, e) {
        var i = h(e),
          o = l(t),
          n = [o],
          r = l(window).scrollTop(),
          a = l("html").outerHeight(!0),
          s = o.parents().filter(":hidden");
        return (
          s.each(function () {
            var t = l(this);
            t.data("style-cache", t.attr("style"));
          }),
          s.css("display", "block"),
          i.byRow &&
            !i.target &&
            (o.each(function () {
              var t = l(this),
                e = t.css("display");
              "inline-block" !== e &&
                "flex" !== e &&
                "inline-flex" !== e &&
                (e = "block"),
                t.data("style-cache", t.attr("style")),
                t.css({
                  display: e,
                  "padding-top": "0",
                  "padding-bottom": "0",
                  "margin-top": "0",
                  "margin-bottom": "0",
                  "border-top-width": "0",
                  "border-bottom-width": "0",
                  height: "100px",
                  overflow: "hidden",
                });
            }),
            (n = p(o)),
            o.each(function () {
              var t = l(this);
              t.attr("style", t.data("style-cache") || "");
            })),
          l.each(n, function (t, e) {
            var o = l(e),
              r = 0;
            if (i.target) r = i.target.outerHeight(!1);
            else {
              if (i.byRow && o.length <= 1) return void o.css(i.property, "");
              o.each(function () {
                var t = l(this),
                  e = t.attr("style"),
                  o = t.css("display");
                "inline-block" !== o &&
                  "flex" !== o &&
                  "inline-flex" !== o &&
                  (o = "block");
                var n = { display: o };
                (n[i.property] = ""),
                  t.css(n),
                  t.outerHeight(!1) > r && (r = t.outerHeight(!1)),
                  e ? t.attr("style", e) : t.css("display", "");
              });
            }
            o.each(function () {
              var t = l(this),
                e = 0;
              (i.target && t.is(i.target)) ||
                ("border-box" !== t.css("box-sizing") &&
                  ((e +=
                    c(t.css("border-top-width")) +
                    c(t.css("border-bottom-width"))),
                  (e += c(t.css("padding-top")) + c(t.css("padding-bottom")))),
                t.css(i.property, r - e + "px"));
            });
          }),
          s.each(function () {
            var t = l(this);
            t.attr("style", t.data("style-cache") || null);
          }),
          u._maintainScroll &&
            l(window).scrollTop((r / a) * l("html").outerHeight(!0)),
          this
        );
      }),
      (u._applyDataApi = function () {
        var o = {};
        l("[data-match-height], [data-mh]").each(function () {
          var t = l(this),
            e = t.attr("data-mh") || t.attr("data-match-height");
          o[e] = e in o ? o[e].add(t) : t;
        }),
          l.each(o, function () {
            this.matchHeight(!0);
          });
      });
    function i(t) {
      u._beforeUpdate && u._beforeUpdate(t, u._groups),
        l.each(u._groups, function () {
          u._apply(this.elements, this.options);
        }),
        u._afterUpdate && u._afterUpdate(t, u._groups);
    }
    (u._update = function (t, e) {
      if (e && "resize" === e.type) {
        var o = l(window).width();
        if (o === n) return;
        n = o;
      }
      t
        ? -1 === r &&
          (r = setTimeout(function () {
            i(e), (r = -1);
          }, u._throttle))
        : i(e);
    }),
      l(u._applyDataApi);
    var t = l.fn.on ? "on" : "bind";
    l(window)[t]("load", function (t) {
      u._update(!1, t);
    }),
      l(window)[t]("resize orientationchange", function (t) {
        u._update(!0, t);
      });
  });
  // -------------------------------------------------------------------

  $.fn.matchHeight._afterUpdate = function (event, groups) {
    $(window).trigger("matchHeight");
  };

  //$('.equalizeable').equalizeHeight('.equalize');

  if (
    $(".project-title-box, .teaser-list div.col, .blog-gallery li").length > 0
  ) {
    $(
      ".project-title-box, .teaser-list div.col, .blog-gallery li"
    ).matchHeight();
  }

  if ($(".equalize").length > 0) {
    $(".equalize").matchHeight();

    $(window).resize(function (e) {
      $(".equalize").matchHeight();
    });

    $(window).on("orientationchange", function (e) {
      $(".equalize").matchHeight({ remove: true });
      $(".equalize").matchHeight();
    });
  }
};
